import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Button } from 'components/Button';

type ProductType = {
  layout?: string;
  isImageEmpty?: boolean;
  withSeparator?: boolean;
};

type CTAType = {
  isCentered?: boolean;
};

const pickSize = (layout: string) => {
  switch (layout) {
    case 'grid':
      return '27rem';
    case 'grid2':
      return '21rem';
    default:
      return '34rem';
  }
};

const pickImageSize = (layout: string, isImageEmpty: boolean | undefined) => {
  switch (layout) {
    case 'grid':
      return '19.1rem';
    case 'grid2':
      return '15.7rem';
    default:
      return '23.1rem';
  }
};

const Wrapper = styled.div<ProductType>`
  width: ${({ layout }) => (layout ? pickSize(layout) : '34rem')};
  position: relative;
`;

const ImageWrapper = styled.div<ProductType>`
  position: relative;
  min-height: ${({ layout, isImageEmpty }) =>
    layout ? pickImageSize(layout, isImageEmpty) : '25rem'};

  .product-image-wrapper {
    min-height: ${({ layout, isImageEmpty }) =>
      layout ? pickImageSize(layout, isImageEmpty) : '25rem'};
  }
`;

const InactiveLayer = styled.div`
  position: absolute;

  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
`;

const OutOfStock = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const OnlyPrice = styled.div``;

const TopStickers = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`;

const Titles = styled.div`
  padding: 1.5rem 0;

  text-align: center;
  text-transform: uppercase;

  border-top: 0.1rem solid ${pickColor('borderLight')};
`;

const CTA = styled.div<CTAType>`
  display: flex;
  justify-content: ${({ isCentered }) => (isCentered ? 'center' : 'space-between')};
  align-items: center;
`;

const HeartIcon = styled(Button)`
  color: ${pickColor('red')};

  &::before {
    content: '|';

    color: ${pickColor('black')};

    margin: 0 1rem;
  }
`;

const StyledButton = styled(Button)<ProductType>`
  width: 17rem;

  justify-content: center;
  align-items: center;

  border-right: ${({ withSeparator }) =>
    withSeparator ? '0.1rem solid rgba(0, 0, 0, 0.1)' : 'none'};
`;

const Notifications = styled.div`
  display: flex;

  margin-left: 1rem;
  margin-bottom: 1rem;
`;

const QtyStickerWrapper = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
`;

export {
  CTA,
  HeartIcon,
  ImageWrapper,
  InactiveLayer,
  Notifications,
  OnlyPrice,
  OutOfStock,
  QtyStickerWrapper,
  StyledButton,
  Titles,
  TopStickers,
  Wrapper,
};
